<div class="row row-padding-bottom client-plans">
  <div class="medium-12" *ngIf="!freezPlan && !userReadOnly">
    <div class="float-right pointer" style="margin: 0 10px;color: #1570EF;display: inline-flex;" (click)="addNewCashflowLine()">
      <i class="material-icons">add</i><span style="position: relative;top: 2px;">Add New Cashflow</span>
    </div>
  </div>
  <div class="medium-12" style="margin-top: 15px;">
    <div class="row no-hover client-todos tax-strategy client-plans badge-tables" style="overflow-y: auto; padding: 0;">
      <div class="medium-12 large-12 tpiq-paginated-table invoices scenarios">
        <table style="margin-top: 0 !important;">
          <thead>
          <tr>
            <th *ngFor="let column of columns">
              <span>{{column.title}}</span>
            </th>
            <th></th>
          </tr>
          </thead>
          <tbody>
          <ng-template [ngIf]="cashflowTableData && cashflowTableData.length == 0">
            <tr class="text-center">
              <td [attr.colspan]="columns.length">
                <div class="callout text-center">
                <p>No Results Found.</p>
                </div>
              </td>
            </tr>
          </ng-template>
          <ng-template [ngIf]="cashflowTableData && cashflowTableData.length > 0">
            <tr *ngFor="let row of cashflowTableData;let i=index">
              <td *ngFor="let col of columns;let idx=index">
                <div class="pointer table-col">
                  {{row[col.name]}}
                </div>
              </td>
              <td>
                <div class='badge-tooltip' *ngIf="!freezPlan && !userReadOnly">
                  <a class='action' data-action='edit' (click)="editCashflow(row, i)"><i class="material-icons strategy-action-icon">mode_edit</i></a>
                  <a class='action' data-action='delete'><span class='todo-del' (click)="deleteCashflowLine(i)"><i class="material-icons delete">delete</i></span></a>
                </div>
              </td>
            </tr>
          </ng-template>
          </tbody>
        </table>
      </div>
    </div>

  </div>
</div>

<div *ngIf="reveal['addNewCashflowLine']">
  <div class="reveal-overlay" [ngClass]="{'tpiq-reveal': reveal['addNewCashflowLine']}">
  </div>
  <div class="reveal tax-strategy-reveal" style="padding: 0; border: none; width: 50%;" [ngClass]="{'tpiq-reveal': reveal['addNewCashflowLine']}">
    <div style="height: 50px; padding: 15px; color: #333333;">
      <span class="float-left">Add Cashflow</span>
      <span class="float-right pointer" (click)="hideReveal('addNewCashflowLine')">X</span>
    </div>
    <div style="padding: 0 15px;">
      <hr style="margin: 0;"/>
    </div>
    <div class="body new-input-fields" style="padding: 15px;">
      <div class="row tax-planning-client" style="height: 70vh;overflow-y: scroll;">
        <div class="medium-6 columns" style="margin-bottom: 15px;">
          <label>
            Type*
            <app-tpiq-select-dropdown [setData]="cashflowTypes" [includeNone]="false" (onValueSelect)="setCashflowType($event, cashflowLine)"
                                   [setDefaultValue]="cashflowLine.type || ''" [setSearchKey]="'name'" [setPlaceHolder]="'Type*'" [setValueKey]="'name'"></app-tpiq-select-dropdown>
          </label>
        </div>
        <div class="medium-6 columns">
          <label>
            Strategy*
            <app-tpiq-select-dropdown [setData]="cashflowStrategies" [includeNone]="false" (onValueSelect)="setStrategyForCashflow($event, cashflowLine)"
                                   [setDefaultValue]="cashflowLine.strategyId || ''" [setSearchKey]="'strategyName'" [setPlaceHolder]="'Strategy*'" [setValueKey]="'strategyId'"></app-tpiq-select-dropdown>
          </label>
        </div>
        <div class="medium-6 columns">
          <label>
            Amount
            <input class="float-left" placeholder="Amount" type="text" [(ngModel)]="cashflowLine.amount" model-numeral [locale]="'USD'" [format]="'$0,0.00'"/>
          </label>
        </div>
        <div class="medium-6 columns" style="margin-bottom: 15px;">
          <label>
            Transaction Type*
            <app-tpiq-select-dropdown [setData]="transactionTypes" [includeNone]="false" (onValueSelect)="setCashflowTransactionType($event, cashflowLine)"
                                   [setDefaultValue]="cashflowLine.transactionType || ''" [setSearchKey]="'name'" [setPlaceHolder]="'Transaction Type*'" [setValueKey]="'name'"></app-tpiq-select-dropdown>
          </label>
        </div>
        <div style="width: 100%; background: rgba(234, 236, 240, 0.5);border-radius: 4px;">
          <div class="medium-12 columns mt-3 mb-3">
            <span class="pointer popup-label" style="color: #1570EF" (click)="toggleAddThirdparty()">
                <i class="icon ion-ios-plus-outline"></i>Third Party
            </span>
          </div>
          <div class="medium-12 columns" *ngIf="isNewThirdpartyAdd">
            <div class="row" style="padding-top: 5px">
              <div class="medium-5 columns">
                <label>Third Party*
                  <input type="text" [(ngModel)]="thirdParty.name" placeholder="Third Party"/>
                </label>
              </div>
              <div class="medium-5 columns">
                <label>Type
                  <app-tpiq-select-dropdown [setData]="types" [includeNone]="false" (onValueSelect)="setType($event)"
                                         [setDefaultValue]="thirdParty.type" [setSearchKey]="'name'" [setPlaceHolder]="'Type'" [setValueKey]="'name'"></app-tpiq-select-dropdown>
                </label>
              </div>
              <div class="medium-2 columns">
              <span class="tpiq-input-search">
                <input class="add-button pointer" type="button" value="Add" (click)="addNewThirdpartyToList()"/>
              </span>
              </div>
            </div>
          </div>
        </div>
        <!--
                <div class="medium-12 columns mt-3" *ngIf="currentPlan && currentPlan.includes('Basic-Plan-397')">
                  <span style="margin-left: 30px; font-size: 12px; color: #f1645a">NOTE: Please upgrade by emailing support@taxplaniq.com</span>
                </div>
        -->
        <div class="medium-6 columns mt-3" style="margin-bottom: 15px;">
          <label>
            Third Party*
            <app-tpiq-select-dropdown [setData]="thirdPartiesList" [includeNone]="false" (onValueSelect)="setThirdPartyForCashflow($event, cashflowLine)"
                                   [setDefaultValue]="cashflowLine.thirdPartyId || ''" [setSearchKey]="'name'" [setPlaceHolder]="'Third Party*'" [setValueKey]="'id'"></app-tpiq-select-dropdown>
          </label>
        </div>
        <div class="medium-6 columns mt-3" style="margin-bottom: 15px;">
          <label>
            Frequency
            <ng-template [ngIf]="cashflowLine.type == 'Recurring'">
              <app-tpiq-select-dropdown [setData]="cashflowFrequencyTypes" [includeNone]="false" (onValueSelect)="setPeriodForCashflow($event, cashflowLine)"
                                     [setDefaultValue]="cashflowLine.frequency || 'Yearly'" [setSearchKey]="'name'" [setPlaceHolder]="'Frequency'" [setValueKey]="'name'"></app-tpiq-select-dropdown>
            </ng-template>
            <ng-template [ngIf]="cashflowLine.type != 'Recurring'">
              <input type="text" placeholder="Frequency" disabled/>
            </ng-template>
          </label>
        </div>
        <div class="medium-6 columns" style="margin-bottom: 15px;">
          <label>
            Payment Date
            <input class="float-left input-field" type="text" tpiq-custom-datepicker [hideYear]="true" [format]="'MM/DD/YYYY'" [mindate]="'past'" [(ngModel)]="cashflowLine.paymentDate"
                   (valueChanged)="setPaymentDate($event, cashflowLine)"  placeholder="Payment Date"/>
          </label>
        </div>
        <div class="medium-12 columns">
          <label>
            Description
            <textarea placeholder="Enter description here..." [(ngModel)]="cashflowLine.description" rows="4"></textarea>
          </label>
        </div>
      </div>
      <div class="row" style="margin-top: 20px;">
        <div class="medium-12">
          <button class="button small float-right" (click)="saveCashflow()">{{(editMode) ? 'Save' : 'Add'}}</button>
          <button class="button small float-right" style="border: 1px solid #D0D5DD;border-radius: 6px;background: #FFFFFF;color:#333333;" (click)="hideReveal('addNewCashflowLine')">Cancel</button>
        </div>
      </div>
    </div>
  </div>
</div>
